import { HighDetailedWebsite, Podcast } from 'blaze-ui/icons/24'
import Styles from './EmptySources.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Icon } from 'blaze-ui/icons/Types'
import { DocHighDetailed, VideoHighDetail } from 'blaze-ui/icons/40'
import { Source } from 'types'
import { AddWebpageButton } from 'screens/Campaign/CampaignContext/AddWebpageModal/AddWebpageButton'
import { UploadButton } from 'screens/Campaign/CampaignContext/UploadButton'

const UploadType = ({ icon: Icon, title, description }: { icon: Icon; title: string; description: string }) => (
  <div className={Styles.iconContainer}>
    <Icon size={40} />
    <div className={Styles.textContainer}>
      <Heading level={5}>{title}</Heading>
      <Text variant="placeholder" color="var(--dark-60)">
        {description}
      </Text>
    </div>
  </div>
)

export const EmptySources = ({ onSourceCreated }: { onSourceCreated: (source: Source) => Promise<any> | void }) => {
  return (
    <div className={Styles.emptyState}>
      <Heading level={5}>Add materials to inspire richer, more detailed content</Heading>
      <div className={Styles.iconsRow}>
        <UploadType icon={HighDetailedWebsite} title="Webpages" description="blog, product" />
        <UploadType icon={VideoHighDetail} title="Videos" description="mp4, mpeg, avi" />
        <UploadType icon={DocHighDetailed} title="Documents" description="pdf, docx, txt" />
        <UploadType icon={Podcast} title="Voice note" description="mp3, wav" />
      </div>
      <div className={Styles.buttonContainer}>
        <AddWebpageButton onSourceCreated={onSourceCreated} />
        <UploadButton variant="secondary" onSourceCreated={onSourceCreated} />
      </div>
    </div>
  )
}
